import { Controller } from "@hotwired/stimulus";

// Keeps the resend link shut until the wait is over, and says how long is
// left. The moment the code was sent comes from the server, so reloading the
// page does not restart the wait.
export default class extends Controller {
  static targets = ["link", "note"];
  static values = { seconds: Number, readyAt: Number, waiting: String };

  connect() {
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnect() {
    clearInterval(this.timer);
  }

  tick() {
    const left = this.readyAtValue - Math.floor(Date.now() / 1000);
    if (left > 0) {
      this.linkTarget.hidden = true;
      this.noteTarget.hidden = false;
      this.noteTarget.textContent = this.waitingValue.replace("%{seconds}", left);
      return;
    }

    this.linkTarget.hidden = false;
    this.noteTarget.hidden = true;
    clearInterval(this.timer);
  }
}
